/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { addClasses } from 'lib/helpers/class.js';
import File from '#lib/components/file-dnd.jsx';
import FilePreview from '#components/file-preview.jsx';
import { AudioPreview } from '#components/audio-preview.jsx';
import ImagePreview from '#components/images/image-preview.jsx';
import { SectionHeading } from '#components/headings.jsx';

export function Media(props) {
    const { form, intro, mediaIntro, jingleFile, mediaJingle, cover, mediaCover } = props;
    return (
        <form className="contents" {...form.props.form}>
            <section className="flex flex-col col-span-full space-y-2">
                <SectionHeading id="intro" subtext={_t.edit.introDescription()}>
                    {_t.edit.intro()}
                </SectionHeading>
                <div className="flex gap-2 justify-between w-[480px]">
                    <div className="w-1/2 flex flex-col">
                        <h2 className="font-bold text-neutral-800 mb-3">{_t.edit.background()}</h2>
                        <FilePreview
                            name="intro"
                            file={intro}
                            coords={intro && intro?.coords}
                            width={480}
                            height={270}
                            accept="image/png, image/jpeg"
                            isGallery={false}
                            {...mediaIntro.handlers}
                        >
                            {({ previewFile }) => {
                                const src = previewFile?.src;
                                return (
                                    <>
                                        {previewFile && (
                                            <ImagePreview imageSrc={src} initialState={previewFile?.coords} />
                                        )}
                                    </>
                                );
                            }}
                        </FilePreview>
                    </div>
                    <div className="w-1/2 flex flex-col h-full">
                        <h2 className="font-bold text-neutral-800 mb-3">{_t.edit.jingle()}</h2>
                        <File
                            name="jingle"
                            existingFiles={[jingleFile]}
                            type="audio"
                            className={addClasses('h-full')}
                            accept="audio/*"
                            {...mediaJingle.handlers}
                        >
                            {({ hasFiles, file, helperProps, clear }) => (
                                <>{hasFiles && !helperProps.isDragging && <AudioPreview file={file} clear={clear} />}</>
                            )}
                        </File>
                    </div>
                </div>
            </section>
            <section>
                <div className="grid grid-cols-1 space-y-2">
                    <SectionHeading id="cover" subtext={_t.edit.coverDescription()}>
                        {_t.edit.cover()}
                    </SectionHeading>
                    <div className="flex flex-col col-span-full space-y-2 w-[480px]">
                        <FilePreview
                            name="cover"
                            file={cover}
                            coords={cover && cover?.coords}
                            width={480}
                            height={270}
                            accept="image/png, image/jpeg"
                            isGallery={false}
                            {...mediaCover.handlers}
                        >
                            {({ previewFile }) => {
                                const src = previewFile?.src;
                                return (
                                    <>
                                        {previewFile && (
                                            <ImagePreview imageSrc={src} initialState={previewFile?.coords} />
                                        )}
                                    </>
                                );
                            }}
                        </FilePreview>
                    </div>
                </div>
            </section>
        </form>
    );
}
